var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-quac"},[_c('banner-principal'),_c('what-is-quac'),_c('how-found'),_c('BenefitQuac'),_c('BreakeNav'),_c('AliadosQuac')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }